import { render, staticRenderFns } from "./phoneNo.vue?vue&type=template&id=2a955aa5&scoped=true&"
import script from "./phoneNo.vue?vue&type=script&lang=js&"
export * from "./phoneNo.vue?vue&type=script&lang=js&"
import style0 from "./phoneNo.vue?vue&type=style&index=0&id=2a955aa5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a955aa5",
  null
  
)

export default component.exports